import i18n from '@/lang/i18n'
import { Nullable } from '@/shared/types/app.types'
import moment from 'moment'

/**
 * Return an string with the amount of days/months/years, based on number of days.
 * i.e., if you want the patient age (which is stored in days), this function will return
 * an string representing the same amount, but in days/months/years, depending if those days are
 * greater than 31, or 365.
 * example 1:  mountPatientAgeString(10) -> "10 days"
 * example 2:  mountPatientAgeString(40) -> "1 month"
 * example 3:  mountPatientAgeString(400) -> "1 year"
 * Null values return an empty string
 */
export function mountPatientAgeString(patientAgeInDays: Nullable<number>): string {
    const DAYS_IN_MONTH = 30
    const DAYS_IN_YEAR = 365
    if (patientAgeInDays === null || patientAgeInDays === undefined) {
        return ''
    }
    if (patientAgeInDays < DAYS_IN_MONTH) {
        return `${patientAgeInDays} ${i18n.tc('global.daysOld', patientAgeInDays)}`
    }
    if (patientAgeInDays < DAYS_IN_YEAR) {
        const patientAgeInMonths = Math.trunc(patientAgeInDays / DAYS_IN_MONTH)
        return `${patientAgeInMonths} ${i18n.tc('global.monthsOld', patientAgeInMonths)}`
    }

    const patientAgeInYears = Math.trunc(patientAgeInDays / DAYS_IN_YEAR)
    return `${patientAgeInYears} ${i18n.tc('global.yearsOld', patientAgeInYears)}`
}

export function getPatientTimeOld(patBirthdate: Nullable<Date>, initDate?: Date): string {
    const currentDate = initDate ? moment(initDate) : moment()
    if (patBirthdate) {
        const monthsOld = currentDate.diff(patBirthdate, 'months')
        if (monthsOld >= 12) {
            const yearsOld = currentDate.diff(patBirthdate, 'years')
            return `${yearsOld} ${i18n.tc('global.yearsOld', yearsOld)}`
        } else if (monthsOld >= 1 && monthsOld < 12) {
            return `${monthsOld} ${i18n.tc('global.monthsOld', monthsOld)}`
        } else {
            const daysOld = currentDate.diff(patBirthdate, 'days')
            return `${daysOld} ${i18n.tc('global.daysOld', daysOld)}`
        }
    }
    return ''
}
